import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './components/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { FGMHopeClinic } from './components/FGMHopeClinic';
import { Booking } from './components/Booking';
import { Contact } from './components/Contact';
import { ArtworkCarousel } from './components/ArtworkCarousel';
import { Footer } from './components/Footer';
import { BookOnlinePage } from './pages/BookOnlinePage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { RecommendationsPage } from './pages/RecommendationsPage';
function HomePage() {
  return <main data-id="element-0">
      <Hero data-id="element-1" />
      <About data-id="element-2" />
      <Services data-id="element-3" />
      <Pricing data-id="element-4" />
      <FGMHopeClinic data-id="element-5" />
      <Booking data-id="element-6" />
      <Contact data-id="element-7" />
      <ArtworkCarousel data-id="element-8" />
    </main>;
}
export function App() {
  return <LanguageProvider data-id="element-9">
      <div className="min-h-screen bg-white selection:bg-teal-100 selection:text-teal-900 w-full overflow-x-hidden" data-id="element-10">
        <Navbar data-id="element-11" />
        <Routes data-id="element-12">
          <Route path="/" element={<HomePage data-id="element-14" />} data-id="element-13" />
          <Route path="/book-online" element={<BookOnlinePage data-id="element-16" />} data-id="element-15" />
          <Route path="/testimonials" element={<TestimonialsPage data-id="element-18" />} data-id="element-17" />
          <Route path="/recommendations" element={<RecommendationsPage data-id="element-20" />} data-id="element-19" />
        </Routes>
        <Footer data-id="element-21" />
      </div>
    </LanguageProvider>;
}